export interface IJSONAPICollection {
  [key: string]: {
    [key: string]: IJSONAPIItem;
  };
  meta: {
    [key: string]: IJSONAPIItem;
  };
}

export interface IJSONAPIType {
  [key: string]: IJSONAPIItem;
}

export interface IJSONAPIItem extends IJSONAPIDataProps {
  relationships?: {
    [key: string]: IJSONAPIData;
  };
  meta?: {
    [key: string]: any;
  };
  links?: {
    [key: string]: string;
  };
  data?: {
    [key: string]: any;
  };
}

export interface IJSONAPIData {
  data: IJSONAPIDataProps;
}

interface IJSONAPIDataProps {
  id: string;
  type: string;
  attributes?: IJSONAPIDataAttributes;
}

export interface IJSONAPIDataAttributes {
  id: string;
  [key: string]: string | IJSONAPIData | IJSONAPIData[];
}

export interface IJSONAPIPagination {
  totalItems: number;
  itemsPerPage: number;
  currentPage: number;
}

export interface IJSONAPIVialotion {
  code: string;
  message: string;
  propertyPath: string;
}

export interface IJSONAPIError {
  response: {
    data: {
      detail: string;
      title: string;
      type: string;
      violations?: IJSONAPIVialotion[];
    };
  };
}

export interface IAPIError {
  errorCodes: string[];
  propertyPaths: string[];
  [key: string]: any;
}

export enum IJSONAPIErrorCodes {
  ExpiredCodeException = "token_is_expired",
  InvalidCodeException = "invalid_token",
  EmailExistsException = "23bd9dbf-6b9b-41cd-a99e-4844bcf3077f",
  NotUniqueError = "23bd9dbf-6b9b-41cd-a99e-4844bcf3077f",
  IsEditor = "is_editor",
  InvalidVAT = "59421d43-d474-489c-b18c-7701329d51a0",
  NumericTooLowError = "ea4e51d1-3342-48bd-87f1-9e672cd90cad",
  MissingPaymentProvider = "e7cbe2e9-88fb-4de7-99f5-cd9d0b073d67",
  MissingPaymentProviderSubscriptionId = "ca04f90a-450d-4611-bc40-a37805c6f05f",
  LastMemberException = "a3f92fa5-8f41-4d60-993f-22ffe636f6f3",
  LastMemberWithPermissionException = "619eebc9-1c36-47e6-b893-bd74a288fc6c",
  UniqueBlockException = "23bd9dbf-6b9b-41cd-a99e-4844bcf3077f",
  TooLowError = "778b7ae0-84d3-481a-9dec-35fdb64b1d78",
  TooHighError = "30fbb013-d015-4232-8b3b-8f3be97a7e14",
  HasDistributedTickets = "d53a91b0-def3-426a-83d7-269da7ab4200",
  TicketsDistributed = "079d7420-2d13-460c-8756-de810eeb37d2",
  LastTicketAndPass = "bef8e338-6ae5-4caf-b8e2-50e7b0579e69",
  OverlappingSubsriptions = "overlapping_subscriptions",
  NotEqualError = "478618a7-95ba-473d-9101-cabd45e49115",
  UserAlreadyHasAReservation = "23bd9dbf-6b9b-41cd-a99e-4844bcf3077f",
  NoVacancyLeft = "30fbb013-d015-4232-8b3b-8f3be97a7e14",
  InvalidCarrier = "439e95cc-bbea-4943-a059-847009ce2901",
  InvalidFlightNumber = "4682d216-ed9b-4b62-80a9-87b0adfd8eeb",
  InvalidDepartureDate = "f13c1ec4-f383-44c6-be72-38551ff0dec9",
}
